/** Where this build is mounted, and how to name a file under it.
 *
 * The game was written assuming it owns the root of its origin: `/assets`,
 * `/content.bundle.json`, `/music`, `/fonts`, `/sw.js`. That is true of a
 * root deploy and false of anything served under a path (GitHub Pages), and the
 * failure mode is total - every atlas, the content bundle and the fonts 404
 * at once, so the app boots to a black screen with no obvious cause.
 *
 * `import.meta.env.BASE_URL` is Vite's own answer, set from the `base` build
 * option, and it always has a trailing slash ("/" at the root). Reading it
 * here rather than in eight places means a build for a new mount point needs
 * no code change at all - only `GAME_BASE=/banners-of-the-realm/ vite build`.
 *
 * The one thing this file must NOT do is guess from `location.pathname`: a
 * deep link inside the app would read its own route as the mount point.
 */

/** Always ends with a slash. "/" when the app owns its origin. */
export const BASE: string = import.meta.env.BASE_URL || "/";

/** `asset("/assets")` -> "/banners-of-the-realm/assets". Leading slash optional. */
export function asset(path: string): string {
  return BASE + path.replace(/^\/+/, "");
}

/** The same, without a trailing slash - what a `baseUrl` option wants. */
export function assetDir(path: string): string {
  return asset(path).replace(/\/+$/, "");
}
